import service from "../util/http";
import request from "../util/request";
import requestBx from "../util/bxzs";
// 删除附件接口
export const deleteFile = (data) => {
  return service({
    url: "/customer/system/delete/file",
    method: "post",
    data,
  });
};
// 质量咨询--------------
// 根据vin获取车主车辆档案
export const getVinData = (data) => {
  return service({
    url: "/customer/quality/vin",
    method: "post",
    data,
  });
};
// 获取品牌
export const getBrand = (data) => {
  return request({
    url: "/manage/model/spinner/for/customer",
    method: "post",
    data,
  });
};
// 根据品牌获取车型
export const getModel = (data) => {
  return request({
    url: "/manage/album/spinner/for/customer",
    method: "post",
    data,
  });
};
// 新建咨询单
export const newSeek = (data) => {
  return service({
    url: "/customer/quality/add",
    method: "post",
    data,
  });
};
//   咨询单新增上传附件接口
export const seekUpload = (data) => {
  return service({
    url: "/customer/quality/upload",
    method: "post",
    data,
  });
};
// 咨询单回复
export const seekReply = (data) => {
  return service({
    url: "/customer/quality/reply",
    method: "post",
    data,
  });
};
// 咨询单详情附件接口
export const seekReplyUpload = (data) => {
  return service({
    url: "/customer/quality/reply/upload",
    method: "post",
    data,
  });
};
// 取消咨询单
export const cancelSeek = (data) => {
  return request({
    url: "/manage/quality/status/for/customer",
    method: "post",
    data,
  });
};
// 咨询管理列表
export const seekList = (data) => {
  return service({
    url: "/customer/quality/list",
    method: "post",
    data,
  });
};
// 索赔单列表 /customer/claim/list
export const claimantList = (data) => {
  return service({
    url: "/customer/claim/list",
    method: "post",
    data,
  });
};
// 索赔单上传文件/customer/claim/upload
export const claimantUpload = (data) => {
  return service({
    url: "/customer/claim/upload",
    method: "post",
    data,
  });
};
// 新建索赔单
export const newClaimant = (data) => {
  return service({
    url: "/customer/claim/add",
    method: "post",
    data,
  });
};
// 索赔单审核
export const climantAudit = (data) => {
  return service({
    url: "/customer/claim/cancel",
    method: "post",
    data,
  });
};
// 订单列表
export const orderList = (data) => {
  return service({
    url: "/customer/order/list",
    method: "post",
    data,
  });
};

// 取消订单
export const orderCancel = (data) => {
  return service({
    url: "/customer/order/cancel",
    method: "post",
    data,
  });
};
// 生成订单
export const newOrder = (data) => {
  return service({
    url: "/customer/order/add",
    method: "post",
    data,
  });
};

// 再次订购
export const orderAgain = (data) => {
  return service({
    url: "/customer/cart/another",
    method: "post",
    data,
  });
};

// 导出订单 /customer/order/export
export const exportOrder = (data) => {
  return service({
    url: "/customer/order/export",
    method: "post",
    responseType: "blob",
    data,
  });
};

// 购物车 加操作
export const addCart = (data) => {
  return service({
    url: "/customer/cart/add",
    method: "post",
    data,
  });
};

// 购物车 减操作
export const minusCart = (data) => {
  return service({
    url: "/customer/cart/delete",
    method: "post",
    data,
  });
};

// 购物车 更新总数
export const updateCart = (data) => {
  return service({
    url: "/customer/cart/update",
    method: "post",
    data,
  });
};

// 获取用户购物车
export const getCart = (data) => {
  return service({
    url: "/customer/cart/get",
    method: "post",
    data,
  });
};

// 导出咨询工单
export const exportSeek = (data) => {
  return service({
    url: "/customer/quality/export",
    method: "post",
    responseType: "blob",
    data,
  });
};

// 获取预设数据
export const getPreset = (data) => {
  return service({
    url: "/customer/claim/getPreset",
    method: "post",
    data,
  });
};

// 获取ECP数据
export const getECPData = (data) => {
  return requestBx({
    url: "/api/claim/part",
    method: "post",
    data,
  });
};

// 根据vin获取ECP数据
export const getECPDataByVIN = (data) => {
  return requestBx({
    url: "/api/claim/vin",
    method: "post",
    data,
  });
};

// 提交索赔单
export const submitClaimant = (data) => {
  return service({
    url: "/customer/claim/submit",
    method: "post",
    data,
  });
};

// 检查质保时间
export const checkWarrantyTime = (data) => {
  return service({
    url: "/customer/warrantyTimeConfig/checkWarranty",
    method: "post",
    data,
  });
};

// 根据索赔单ID检查质保时间
export const checkWarrantyTimeByClaimId = (data) => {
  return service({
    url: "/customer/warrantyTimeConfig/checkWarrantyByClaimId",
    method: "post",
    data,
  });
};

// 修改索赔单
export const editClaimant = (data) => {
  return service({
    url: "/customer/claim/updateClaim",
    method: "post",
    data,
  });
};

// 取消索赔单
export const cancelClaimant = (data) => {
  return service({
    url: "/customer/claim/cancel",
    method: "post",
    data,
  });
};

// 撤回索赔单
export const revokeClaimant = (data) => {
  return service({
    url: "/customer/claim/revoke",
    method: "post",
    data,
  });
};

// 历史记录
export const auditHistoryList = (data) => {
  return service({
    // url: "/customer/claim/auditHistoryList",
    url: "/customer/claim/newAuditHistoryList",
    method: "post",
    data,
  });
};

// 消息列表
export const messageList = (data) => {
  return service({
    url: "/customer/claim/messageList",
    method: "post",
    data,
  });
};

// 已读
export const messageReading = (data) => {
  return service({
    url: "/customer/claim/messageReading",
    method: "post",
    data,
  });
};

// 删除
export const messageDelete = (data) => {
  return service({
    url: "/customer/claim/messageDelete",
    method: "post",
    data,
  });
};

// 导出索赔单
export const exportClaim = (data) => {
  return service({
    url: "/customer/claim/export",
    method: "post",
    responseType: "blob",
    data,
  });
};

// 导出索赔单
export const settlementExport = (data) => {
  return service({
    url: "/customer/claim/settlementExport",
    method: "post",
    responseType: "blob",
    data,
  });
};
